import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-delete-confirmation',
    standalone: false,
    templateUrl: './delete-confirmation.component.html',
    styleUrl: './delete-confirmation.component.css'
})
export class DeleteConfirmationComponent {
    @Input() isOpen: boolean = false;
    @Input() title: string = '';
    @Input() message: string = '';
    @Input() isProcessing: boolean = false;
    /** Optional hint shown while processing (e.g. long-running delete). */
    @Input() processingHint = '';
    /** Default message when processing and no custom hint is provided. */
    @Input() defaultProcessingMessage = 'Please wait while this completes. Do not close this window.';
    /** Raise when opened inside another modal (e.g. Visit Details popover). */
    @Input() backdropZIndex = 100005;

    @Output() confirm = new EventEmitter<void>();
    @Output() cancel = new EventEmitter<void>();

    onConfirm(): void {
        this.confirm.emit();
    }

    onCancel(): void {
        this.cancel.emit();
    }

    onBackdropClick(event: MouseEvent): void {
        if ((event.target as HTMLElement).classList.contains('modal-backdrop')) {
            this.onCancel();
        }
    }
}
